import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Col } from '@thd-olt-component-react/grid';
import { CheckAvailabilityContext } from '../CheckAvailabilityContext';
import { InputForm } from './subcomponents/inputForm/InputForm';
import '../styles/check-availability.scss';
import './subcomponents/inputForm/input-form.scss';
import '../styles/pickup-drawer.scss';

export const PickupDrawerInputForm = ({ onSubmit, errorMessage }) => {
  const {
    inputHeaderTitle,
  } = useContext(CheckAvailabilityContext);

  const [input, setInput] = useState('');

  const onInputChange = (event) => {
    const santizeInput = event?.target?.value?.replace(/[^A-Za-z0-9]+/, '');
    setInput(santizeInput);
  };

  return (
    <div className="input-form pickup-drawer">
      { inputHeaderTitle
            && (
              <Col nopadding className="pickup-drawer__title">
                <b>{inputHeaderTitle}</b>
              </Col>
            )}
      <Col nopadding>
        <form
          id="zip-code-availability-form"
          onSubmit={(event) => onSubmit}
        >
          <Col fallback="2.3" nopadding>
            <span className="form-input">
              <input
                // ref={inputElement}
                type="text"
                pattern="[A-Za-z0-9]+"
                placeholder="Zip Code, City, State, or Store Number"
                maxLength="25"
                className="form-input__field pickup-drawer__input-bar"
                id="check-availability__zip-code"
                name="check-availability__zip-code"
                autoComplete="off"
                onChange={onInputChange}
                value={input}
              />
            </span>
          </Col>
          <Col fallback="1" nopadding>
            <button
              type="submit"
              id="pickup-drawer-formButton"
              className="bttn input-group--inline__bttn pickup-drawer__search-btn"
            >
              <span className="bttn__content pickup-drawer__search-btn">
                <img
                  className="pickup-drawer__magnify-img"
                  width="30px"
                  height="30px"
                  alt="submit new location button"
                  src="https://assets.homedepot-static.com/images/v1/magnify-symbol-white.svg"
                />
              </span>
            </button>
          </Col>
          <Col fallback="12" nopadding className="check-availability__error-text">
            {errorMessage}
          </Col>
        </form>
      </Col>
    </div>
  );
};

PickupDrawerInputForm.propTypes = {
  onSubmit: PropTypes.func,
  errorMessage: PropTypes.string
};

PickupDrawerInputForm.defaultProps = {
  onSubmit: () => {},
  errorMessage: 'We\'re Sorry, but we cannot find a Home Depot Store that meets your search criteria.'
};